/**
 * Énumeration pour les différents rôles des utilisateurs.
 */
export enum Role {
    Administrateur = 1,
    Producteur = 2
}
